import React from 'react';
import { StarRating } from './ui/StarRating';
import { CheckCircle2 } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age?: number;
  text: string;
  imageSrc: string;
  verified?: boolean;
}
export function TestimonialCard({
  name,
  age,
  text,
  imageSrc,
  verified = true
}: TestimonialCardProps) {
  return <div className="p-4 rounded-lg border border-gray-100 shadow-sm flex flex-col sm:flex-row gap-4 mb-4" style={{
    backgroundColor: '#EDF9FF'
  }} data-id="element-18">
      <div className="flex-shrink-0" data-id="element-19">
        <img src={imageSrc} alt={name} className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover border-2 border-gray-100" data-id="element-20" />
      </div>
      <div className="flex-1" data-id="element-21">
        <div className="flex items-center justify-between mb-1" data-id="element-22">
          <StarRating size={14} data-id="element-23" />
          {verified && <span className="flex items-center gap-1 text-xs text-green-600 font-medium" data-id="element-24">
              <CheckCircle2 size={12} data-id="element-25" /> Verified Purchase
            </span>}
        </div>
        <p className="text-gray-700 text-lg mb-2 leading-6" data-id="element-26">"{text}"</p>
        <div className="text-xs font-bold text-gray-900" data-id="element-27">
          {name}
          {age ? `, ${age}` : ''}
        </div>
      </div>
    </div>;
}